export default function getInputsComplete(state, inputs, index) {
  const result = {
    mustFilledCount: 0,
    filledCount: 0,
    items: {}
  }

  for (const key in inputs) {
    const obj = inputs[key]

    if (Array.isArray(obj)) {
      const arrayResult = {
        mustFilledCount: 0,
        filledCount: 0,
        items: {}
      }
      obj.forEach((inputsInner, inputsInnerIndex) => {
        let r = getInputsComplete(state, inputsInner, inputsInnerIndex)
        if (r.mustFilledCount) {
          if(inputsInnerIndex === 0) {
            arrayResult.mustFilledCount += r.mustFilledCount
            arrayResult.filledCount += r.filledCount
          }

          Object.keys(r.items).forEach(arrayItemKey => {
            if(r.items[arrayItemKey]) {
              return arrayResult.items[arrayItemKey] = true
            }
            if(!arrayResult.items.hasOwnProperty(arrayItemKey)) {
              result.items[arrayItemKey] = false
            }
          })
        }
      })

      result.mustFilledCount += arrayResult.mustFilledCount
      result.filledCount += arrayResult.filledCount
      Object.assign(result.items, arrayResult.items)
    } else {
      if (typeof obj.check === 'function') {
        const r = obj.check(state, index)
        result.mustFilledCount += 1
        result.filledCount += r ? 1 : 0
        const specKey = obj.translateName || key
        result.items[specKey] = r
      }
    }
  }

  return result
}
